import {Action} from '@ngrx/store';
import {Employee} from '../../models/employee/employee.model';
import {type} from '../store.util';

export const UserActionTypes = {
    AUTHENTICATED: type('[users] Authenticated'),
    AUTHENTICATED_SUCCESS: type('[users] Authenticated success'),
    REDIRECTED_URL: type('[users] RedirectedUrl'),
    REDIRECTED_URL_SUCCESS: type('[users] RedirectedUrl success'),

    LOGOUT_ACTION: type('[users] Logout success'),

    LOADED: type('[users] Loaded'),
    LOADED_SUCCESS: type('[users] Loaded success'),
};

export class AuthenticatedAction implements Action {
    public type: string = UserActionTypes.AUTHENTICATED;

    constructor() {
    }
}

export class AuthenticatedSuccessAction implements Action {
    public type: string = UserActionTypes.AUTHENTICATED_SUCCESS;

    constructor() {
    }
}

export class RedirectedUrlAction implements Action {
    public type: string = UserActionTypes.REDIRECTED_URL;

    constructor(public payload?: { redirectedUrl: string }) {
    }
}

export class RedirectedUrlSuccessAction implements Action {
    public type: string = UserActionTypes.REDIRECTED_URL_SUCCESS;

    constructor(public payload: { redirectedUrl: string }) {
    }
}

export class LoadedAction implements Action {
    public type: string = UserActionTypes.LOADED;

    constructor(public payload?: { employee: Employee }) {
    }
}

export class LoadedSuccessAction implements Action {
    public type: string = UserActionTypes.LOADED_SUCCESS;

    constructor(public payload: { employee: Employee }) {
    }
}
export class LogoutAction implements Action {
    public type: string = UserActionTypes.LOGOUT_ACTION;
    constructor(public payload?: {}) {
    }
}

export type UserActions =
    AuthenticatedAction |
    AuthenticatedSuccessAction |
    RedirectedUrlAction |
    RedirectedUrlSuccessAction |
    LoadedAction |
    LoadedSuccessAction |
    LogoutAction;
